import { isUserAuthenticated } from "./auth";
import { resetUnreadMessageCounter } from "@/server/services/counterService";

import {
  getChatFromLocalDB,
  updateChatInLocalDB,
} from "@/indexedDB/services/chats";

export const resetChatUnreadMessages = async ({
  chatId,
  // signal,
}: {
  chatId: string;
  // signal?: AbortSignal;
}): Promise<void> => {
  // if no payload
  if (!chatId) {
    return;
  }

  // extra check if auth is present
  const userFingerPrint = isUserAuthenticated();
  if (!userFingerPrint) {
    throw new Error("Auth not present");
  }

  try {
    // check if chat exists in local db
    const chatDetails = await getChatFromLocalDB(chatId);
    if (chatId !== chatDetails?.id) {
      return;
    }

    // TO DO => improve reset counter logic
    // removed existing counter validation because of the reset counter's weird logic
    // if (chatDetails.unreadCount && chatDetails.unreadCount > 0) {

    //  optimistic update in local db
    await updateChatInLocalDB(chatId, {
      unreadCount: 0,
    });

    await resetUnreadMessageCounter(chatId);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    // if (error instanceof Error && error.message) throw error;
    // throw new Error("Error sending message");
  }
};
